import { Component, Input, OnInit } from '@angular/core';
import { EQuestionType, EDisplayQtyMode } from '../question-editor/question-editor.component';

export enum ELinkCondition 
{
  None = 0,
  ValueRange = 1,
  MoreThan = 2,
  LessThan = 3
}

@Component({
  selector: 'app-link-infos-edit',
  templateUrl: './link-infos-edit.component.html',
  styleUrls: ['./link-infos-edit.component.scss']
})
export class LinkInfosEditComponent implements OnInit {

  constructor() { }

  @Input() link:any;
  @Input() linkView:any;
  @Input() graph:any;

  ngOnInit(): void {
    this.link_condition_types_property = this.condition_types();
  }

  public link_condition_types_property;
  public ELinkCondition = ELinkCondition;

  condition_types() : Array<any> {
    let myEnum = [];
    let objectEnum = Object.keys(ELinkCondition);
    const values = objectEnum.slice( 0 , objectEnum.length / 2 );
    const keys = objectEnum.slice( objectEnum.length / 2 );

    for (let i = 0 ; i < objectEnum.length/2 ; i++ ) {
      myEnum.push( { key: keys[i], value: values[i] } ); 
    }
    return myEnum;
  }

  /** Modifie le label du lien en fonction de la condition sélectionnée
   * @param event  nouvelle valeur du model.
   */
  changeLinkLabel(event: any) {
    var label = "";
    if(this.link.condition.type == ELinkCondition.ValueRange && this.link.condition.start != undefined && this.link.condition.stop != undefined)
      label = this.link.condition.start + ' - ' + this.link.condition.stop;
    else if (this.link.condition.type == ELinkCondition.MoreThan && this.link.condition.start != undefined)
      label = '> ' + this.link.condition.start;
    else if (this.link.condition.type == ELinkCondition.LessThan && this.link.condition.start != undefined)
      label = '< ' + this.link.condition.start;
    else if (this.link.condition.type == ELinkCondition.None)
      label = '*';

    this.linkView.model.label(0, { attrs: { text: { text: label } } });
    this.linkView.model.set('condition', this.link.condition);
  }

  /** Vérifie que la question d'où provient le lien est de type quantité */
  isSourceQuantityQuestion() {
    let question = this.graph.getCell(this.link.source).attributes;
    return question.typequestion == EQuestionType.Quantity && question.display != EDisplayQtyMode.UniqueChoice;
  }
}
